<template>
  <div class="dataSource" style="margin-top: 10px;width: 1440px;margin:0 auto;">
    <el-row justify="center" type="flex">
      <el-col>
        <div style="font-size:16px;color: #909399;margin-top:16px;margin-bottom:20px;">Data source</div>
        <el-select v-model ="dataSource" @change="change">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "dataSource",
    data(){
        return {
          options:[{
            value:'HBase',
            label:'HBase'
          },{
            value:'Oracle',
            label:'Oracle'
          }],
          dataSource:'HBase'
        }
    },
    created(){
      //this.change('HBase');
      this.query();
    },
    methods:{
      change:function(value){
        this.dataSource = value;
        this.$axios({ 
          method:'post',
          url:'/hlsii/hlsii/admin/changeDataSource/' + this.dataSource
        }).then((response) => {
          if(response.data === true){
            //this.$message('Operation successful');
          }
        })
      },
      query:function(){
        this.$axios({ 
          method:'get',
          url:'/hlsii/hlsii/user/getDataSource'
        }).then((response) => {
          this.dataSource = response.data.name;
        }).catch((error) => {
          this.dataSource = 'HBase'
        })
      }
    }
  }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/page/activePublic/dataSource.vue